import { ApolloLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { createUploadLink } from "apollo-upload-client";
import { silentRequest } from "authConfig";
import { redirectToLoginFromAuthFailure } from "features/Authentication/authRecovery";
import { msalInstance } from "msalInstance";
import { GetUrl } from "../helpers/get-url";
import { OmitDeep } from "../helpers/object-helpers";

export const CleanTypeNameMiddleWare = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    operation.variables = OmitDeep(operation.variables, ["__typename"]);
  }
  return forward(operation).map((data) => {
    return data;
  });
});
const uri = `${GetUrl()}/graphql`;
export const HttpMiddleWare = createUploadLink({
  uri,
});
export const AuthMiddleWare = setContext(async (_, { headers }) => {
  const account = msalInstance.getActiveAccount();
  if (!account) {
    redirectToLoginFromAuthFailure({
      instance: msalInstance,
    });
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...silentRequest,
      account: account,
    });

    return {
      headers: {
        ...headers,
        authorization: `Bearer ${response.accessToken}`,
      },
    };
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      redirectToLoginFromAuthFailure({
        instance: msalInstance,
      });
    }

    throw error;
  }
});
